import React, { useEffect, useState } from "react";
import { ReactComponent as IconNoticeClose } from "./icon/icon_notice_close.svg";
import { ReactComponent as IconNoticeDivide } from "./icon/icon_notice_divide.svg";
import { ReactComponent as IconNoticeFintech } from "./icon/icon_notice_fintech.svg";
import { ReactComponent as IconNoticeGroup } from "./icon/icon_notice_group.svg";
// import { getNoticeContent, getNoticeTitle } from "../../firebase";
import { useLocation } from "react-router-dom";
import styles from "./index.module.scss";

const SuspensionNotice = () => {
  const location = useLocation();
  // const [title, setTitle] = useState("");
  // const [content, setContent] = useState("");
  // const [toggle, setToggle] = useState(false);
  // const localFirstIn = window.localStorage.getItem("firstIn");

  // useEffect(() => {
  //   const fetchNoticeTitle = async () => {
  //     try {
  //       const res = await getNoticeTitle();
  //       if (res) {
  //         setTitle(res.asString());
  //       }
  //     } catch (error) {
  //       console.log("Error fetching notice title:", error);
  //     }
  //   };

  //   fetchNoticeTitle();
  // }, []);

  // useEffect(() => {
  //   const fetchNoticeContent = async () => {
  //     try {
  //       const res = await getNoticeContent();
  //       if (res) {
  //         setContent(res.asString());
  //       }
  //     } catch (error) {
  //       console.log("Error fetching notice title:", error);
  //     }
  //   };

  //   fetchNoticeContent();
  // }, []);

  if (!location.pathname.startsWith("/loan")) return null;

  return (
    <>
      <div className={styles.notice}>
        <div className={styles.layout}>
          <IconNoticeClose
            className={styles.close}
            onClick={() => {
              window.location.href = "/";
            }}
          />
          <div className={styles.noticeBanner}>公告</div>
          <div className={styles.noticeTitle}>暫停線上申貸</div>
          <div className={styles.noticeContent}>
            親愛的客戶您好：
            因應營運策略調整與服務升級，自即日起將不再受理貸款相關申請。未來我們將專注於提供
            更具規模與專業性的金融服務， 感謝您的理解與支持。
          </div>
          <button
            className={styles.homeBtn}
            onClick={() => {
              window.location.href = "/";
            }}
          >
            回首頁
          </button>
          <div className={styles.imgGroup}>
            <IconNoticeGroup />
            <IconNoticeDivide />
            <IconNoticeFintech />
          </div>
        </div>
      </div>
    </>
  );
};

export default SuspensionNotice;
